/**
 * 아이템 정의. 이름과 회복량은 `items.json`.
 * 실제 이미지는 코드로 생성한 도트 아이콘을 쓰고, public/assets 에 파일을 넣으면 교체된다.
 */

import seed from './items.json';
import { emitDataReloadSoon, replaceArray, replaceRecord, requireRecord } from './catalog';

import type { EquipSlot } from './equipment';

export type ItemTab = 'equip' | 'use' | 'setup' | 'etc' | 'cash';

export interface EquipSpec {
  slot: EquipSlot;
  weaponId?: string;
  watkMin?: number;
  watkMax?: number;
  defMin?: number;
  defMax?: number;
  accMin?: number;
  accMax?: number;
  upgrades?: number;
  lookTint?: number;
}

export interface ScrollSpec {
  target: 'weapon' | 'armor';
  success: number;
  boom: number;
  watk?: number;
  def?: number;
}

export interface ItemDef {
  id: string;
  name: string;
  tab: ItemTab;
  description: string;
  texture: string;
  use?: { hp?: number; mp?: number };
  equip?: EquipSpec;
  scroll?: ScrollSpec;
  price: number;
}

export const ITEMS: Record<string, ItemDef> = structuredClone(seed.ITEMS) as Record<string, ItemDef>;

export const STARTING_INVENTORY: { itemId: string; count: number }[] = structuredClone(
  seed.STARTING_INVENTORY,
) as { itemId: string; count: number }[];

export let STARTING_MESO = seed.STARTING_MESO;

export const TAB_LABELS: Record<ItemTab, string> = {
  equip: '장비',
  use: '소비',
  setup: '설치',
  etc: '기타',
  cash: '캐시',
};

export const TAB_ORDER: readonly ItemTab[] = ['equip', 'use', 'setup', 'etc', 'cash'];

export function applyItems(raw: unknown): void {
  const data = requireRecord(raw, 'items.json');
  replaceRecord(ITEMS, structuredClone(requireRecord(data.ITEMS, 'ITEMS')) as Record<string, ItemDef>);
  if (!Array.isArray(data.STARTING_INVENTORY)) {
    throw new Error('items.json: STARTING_INVENTORY 배열이 아닙니다');
  }
  replaceArray(
    STARTING_INVENTORY,
    data.STARTING_INVENTORY as { itemId: string; count: number }[],
  );
  if (typeof data.STARTING_MESO !== 'number') throw new Error('items.json: STARTING_MESO 가 없습니다');
  STARTING_MESO = data.STARTING_MESO;
}

if (import.meta.hot) {
  import.meta.hot.accept('./items.json', (mod) => {
    if (!mod?.default) return;
    applyItems(mod.default);
    emitDataReloadSoon();
  });
}
